module.exports = __webpack_public_path__ + "img/live.adf14365.gif";